import { useDispatch } from 'react-redux';
import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';
import { setUser } from '~/redux/reducers/auth';
import type { User } from '~/types';
import { useEffect } from 'react';

export const useRefreshCurrentUser = () => {
  const currentUserQuery = graphql(`
    query currentUser {
      currentUser {
        externalId
        firstName
        id
        lastName
        role
        organization {
          id
          name
        }

        companies {
          code
          id
          name
          organization {
            id
            name
          }
          locations {
            addressLine1
            city
            country
            id
            name
            region
            zipCode
          }
        }
      }
    }
  `);

  const resp = useGraphqlQuery(currentUserQuery, ['cur']);
  const user = resp?.data?.currentUser;

  const dispatch = useDispatch();
  useEffect(() => {
    if (!user) return;
    dispatch(setUser(user as User));
  }, [dispatch, user]);

  return resp;
};
